module.exports = __webpack_public_path__ + "static/media/icono_dia.b87758bd.svg";